
import { Form } from "./Form";
import { FormSuccess } from "./Form-success";

export const UserPassword = {
  Form,
  FormSuccess
};